import _styled from "@emotion/styled-base";
import React from 'react';

var SectionWrapper = _styled("div", {
  target: "e16nk4fj0",
  label: "SectionWrapper"
})(function (_ref) {
  var isBorderRound = _ref.isBorderRound;
  return isBorderRound && "border-radius: 7px";
}, ";", function (_ref2) {
  var hasPadding = _ref2.hasPadding;
  return hasPadding && "padding: 1.5rem";
}, ";background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, ";box-shadow:0 12px 30px 0 rgba(0,0,0,0.04);max-width:940px;width:100%;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.MQ.M;
}, "{", function (_ref5) {
  var hasPadding = _ref5.hasPadding;
  return hasPadding && "padding: 2.5rem";
}, ";}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.MQ.L;
}, "{margin:auto;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TZWN0aW9uQ29udGFpbmVyL2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJaUMiLCJmaWxlIjoiLi4vLi4vc3JjL1NlY3Rpb25Db250YWluZXIvaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHsgYm9vbCwgbm9kZSB9IGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgU2VjdGlvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuXHQkeyh7IGlzQm9yZGVyUm91bmQgfSkgPT4gaXNCb3JkZXJSb3VuZCAmJiBgYm9yZGVyLXJhZGl1czogN3B4YH07XG5cdCR7KHsgaGFzUGFkZGluZyB9KSA9PiBoYXNQYWRkaW5nICYmIGBwYWRkaW5nOiAxLjVyZW1gfTtcblx0YmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnMud2hpdGV9O1xuXHRib3gtc2hhZG93OiAwIDEycHggMzBweCAwIHJnYmEoMCwgMCwgMCwgMC4wNCk7XG5cdG1heC13aWR0aDogOTQwcHg7XG5cdHdpZHRoOiAxMDAlO1xuXG5cdCR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuTVEuTX0ge1xuXHRcdCR7KHsgaGFzUGFkZGluZyB9KSA9PiBoYXNQYWRkaW5nICYmIGBwYWRkaW5nOiAyLjVyZW1gfTtcblx0fVxuXG5cdCR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuTVEuTH0ge1xuXHRcdG1hcmdpbjogYXV0bztcblx0fVxuYFxuLyoqXG4gKiBTZWN0aW9uIENvbnRhaW5lciB0aGF0IHdyYXBzIGNvbnRleHQgd2l0aCBhIHdoaXRlIGJhY2tncm91bmQgYW5kIGRyb3BzaGFkb3dcbiAqXG4gKiBAcGFyYW0ge05vZGV9IHByb3BzLmNoaWxkcmVuIDo6IGNvbnRleHQgdGhhdCB3aWxsIGJlIHdyYXBwZWQgYnkgdGhlIFNlY3Rpb24gQ29udGFpbmVyXG4gKiBAcGFyYW0ge0Jvb2xlYW59IHByb3BzLmlzQm9yZGVyUm91bmQgOjogZGVjbGFyZXMgaWYgdGhlIGJvcmRlciBzaG91bGQgYmUgcm91bmRlZFxuICovXG5leHBvcnQgZnVuY3Rpb24gU2VjdGlvbkNvbnRhaW5lcih7IGNoaWxkcmVuLCBoYXNQYWRkaW5nID0gdHJ1ZSwgaXNCb3JkZXJSb3VuZCA9IHRydWUgfSkge1xuXHRyZXR1cm4gKFxuXHRcdDxTZWN0aW9uV3JhcHBlciBoYXNQYWRkaW5nPXtoYXNQYWRkaW5nfSBpc0JvcmRlclJvdW5kPXtpc0JvcmRlclJvdW5kfT5cblx0XHRcdHtjaGlsZHJlbn1cblx0XHQ8L1NlY3Rpb25XcmFwcGVyPlxuXHQpXG59XG5cblNlY3Rpb25Db250YWluZXIucHJvcFR5cGVzID0ge1xuXHRjaGlsZHJlbjogbm9kZS5pc1JlcXVpcmVkLFxuXHRpc0JvcmRlclJvdW5kOiBib29sLFxufVxuIl19 */"));
/**
 * Section Container that wraps context with a white background and dropshadow
 *
 * @param {Node} props.children :: context that will be wrapped by the Section Container
 * @param {Boolean} props.isBorderRound :: declares if the border should be rounded
 */


export function SectionContainer(_ref7) {
  var children = _ref7.children,
      _ref7$hasPadding = _ref7.hasPadding,
      hasPadding = _ref7$hasPadding === void 0 ? true : _ref7$hasPadding,
      _ref7$isBorderRound = _ref7.isBorderRound,
      isBorderRound = _ref7$isBorderRound === void 0 ? true : _ref7$isBorderRound;
  return /*#__PURE__*/React.createElement(SectionWrapper, {
    hasPadding: hasPadding,
    isBorderRound: isBorderRound
  }, children);
}